<template>
  <v-container class="pa-2 modern-bitacora-tooltip">
    <div v-if="loading" class="text-center pa-6">
      <v-progress-circular indeterminate color="primary" size="24" width="2" class="mb-2"></v-progress-circular>
      <div class="caption grey--text">Cargando bitácora...</div>
    </div>

    <div v-else-if="bitacora.length > 0">
      <div class="px-2 py-1 mb-2 border-bottom d-flex align-center">
        <v-icon x-small color="primary" class="mr-2">fas fa-history</v-icon>
        <span class="caption font-weight-black text-uppercase tracking-wider primary--text">Historial de Producción</span>
      </div>
      
      <v-simple-table dense class="modern-mini-table transparent-table shadow-none">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="caption font-weight-black">Fecha</th>
              <th class="caption font-weight-black">Responsable</th>
              <th class="caption font-weight-black text-right">{{ process.unit_m2 ? 'm²' : 'Cant.' }}</th>
              <th class="caption font-weight-black">Equipo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in bitacora" :key="item.id">
              <td class="caption">{{ item.created_at | moment("D/MM/YY") }}</td>
              <td class="caption opacity-80">{{ item.created_by }}</td>
              <td class="caption font-weight-bold text-right primary--text">
                {{ process.unit_m2 ? (item.mts2 | number('0.00')) : (item.qty | number('0.00')) }}
              </td>
              <td class="caption">
                <v-chip x-small label class="font-weight-bold grey lighten-4">{{ item.equipment_name }}</v-chip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="d-flex justify-end align-center mt-3 pt-2 border-top">
        <span class="caption grey--text mr-2 text-uppercase">Total Consolidado:</span>
        <span class="body-2 font-weight-black primary--text">
          {{ process.unit_m2 ? (totalMts2 | number('0.00')) : (totalQty | number('0.00')) }}
          <small class="caption">{{ process.unit_m2 ? 'm²' : 'un' }}</small>
        </span>
      </div>
    </div>

    <div v-else class="text-center pa-6">
      <v-icon size="32" color="grey lighten-2" class="mb-2">fas fa-folder-open</v-icon>
      <div class="caption grey--text font-weight-bold">Sin registros de avance aún</div>
    </div>
  </v-container>
</template>

<script>
import { fetchBitacora } from '@/api/production'

export default {
  name: 'BitacoraDetailsPlanner',
  props: ['process'],
  data() {
    return {
      bitacora: [],
      loading: true
    }
  },
  computed: {
    totalMts2() {
      return this.bitacora.reduce((t, r) => t + parseFloat(r.mts2 || 0), 0)
    },
    totalQty() {
      return this.bitacora.reduce((t, r) => t + parseFloat(r.qty || 0), 0)
    }
  },
  methods: {
    async getBitacoraData() {
      if (!this.process || !this.process.process) {
        this.loading = false
        return
      }
      try {
        const query = `process_order=${this.process.process}&page=1&page_size=100`
        const response = await fetchBitacora(query)
        this.bitacora = response.results || []
      } catch (e) {
        console.error('Error fetching bitacora:', e)
      } finally {
        this.loading = false
      }
    }
  },
  created() {
    this.getBitacoraData()
  }
}
</script>

<style scoped>
.modern-bitacora-tooltip { min-width: 320px; color: #fff !important; }
.transparent-table { background: transparent !important; }
.transparent-table >>> table { background: transparent !important; }
.transparent-table >>> th { color: rgba(255,255,255,0.6) !important; border-bottom: 1px solid rgba(255,255,255,0.1) !important; }
.transparent-table >>> td { color: rgba(255,255,255,0.9) !important; border-bottom: 1px solid rgba(255,255,255,0.05) !important; padding: 4px 8px !important; }
.border-bottom { border-bottom: 1px solid rgba(255,255,255,0.1); }
.border-top { border-top: 1px solid rgba(255,255,255,0.1); }
.opacity-80 { opacity: 0.8; }
.tracking-wider { letter-spacing: 1px; }
.shadow-none { box-shadow: none !important; }
</style>